export const SEARCH_PAGE_SIZE_OPTIONS = [50, 75, 100];

export const SEARCH_CATEGORIES = [
  {
    id: 'loan_advisor_name',
    label: 'Loan Advisor',
  },
  {
    id: 'manager_name',
    label: 'Sales Manager',
  },
  {
    id: 'borrower_phone_number',
    label: 'Phone Number',
  },
  {
    id: 'loan_id',
    label: 'Loan Number',
  },
];

export const HEIGHTS = {
  TABLE_CARD: 600,
};

export const validationRules: Record<string, { regex: RegExp; message: string }> = {
  borrower_phone_number: {
    regex: /[^0-9()\-+\s.]/,
    message: 'Invalid characters for a phone number',
  },
  loan_id: {
    regex: /\D/,
    message: 'Please enter numbers only',
  },
  loan_advisor_name: {
    regex: /[^a-zA-Z\s]/,
    message: 'Please enter letters only',
  },
  manager_name: {
    regex: /[^a-zA-Z\s]/,
    message: 'Please enter letters only',
  },
};
